import React from 'react';
import ReactDOM from 'react-dom/client';
import WorldSeedUI from './components/WorldSeedUI';

function App() {
  return (
    <div className="app">
      <WorldSeedUI />
    </div>
  );
}

export default App;

// Mount the React component to a div with id="react-ui" that we'll create
const createReactUI = () => {
  // Check if container already exists
  let container = document.getElementById('react-ui');
  
  if (!container) {
    // Create container if it doesn't exist
    container = document.createElement('div');
    container.id = 'react-ui';
    document.body.appendChild(container);
  }
  
  // Force cursor to be visible in the container and all children
  container.style.cursor = 'auto';
  
  // Create root and render
  const root = ReactDOM.createRoot(container);
  root.render(<App />);
};

// Initialize when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', createReactUI);
} else {
  createReactUI();
} 